import {I9DocumentInfoDto, I9DocumentTypesEnum} from '@swipejobs/i9-document-validations-react';

export const convertDocumentListToMap = (documents: I9DocumentInfoDto[]) => {
    const obj: Partial<Record<I9DocumentTypesEnum, I9DocumentInfoDto>> =
        documents?.reduce((prev, curr) => ({ ...prev, [curr.documentType]: curr }), {}) || [];
    return obj;
};

export default convertDocumentListToMap;



// WEBPACK FOOTER //
// ./src/utils/map-document-validation.ts